import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import { Stack } from "@curves/ui-base";

export const InfoCard = ({ className, link, onClick, children, ...rest }) => {
    const containerProps = {
        className: clsx('info-card', className),
        component: 'div',
        justifyContent: 'start',
        alignItems: 'center',
        onClick,
        ...rest,
    };

    if (link) {
        containerProps.component = NavLink;
        containerProps.to = link;
    }

    return <Stack {...containerProps}>{children}</Stack>;
};

InfoCard.propTypes = {
    className: PropTypes.string,
    link: PropTypes.string,
    handleOnClick: PropTypes.func,
    children: PropTypes.any,
};

export default InfoCard;
